

export default {
    totalSuppliesOrders: [],
    suppliesOrders: [],
    suppliesOrdersFiltered: [],
    
  
}
